export default __webpack_public_path__ + "11e31611345d4675590853a70a1f936e.png";